import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  analyzeTypologies,
  analyzeTypologiesSuccess,
  resetTypologyAnalysis
} from '../../../redux/actions/trm/typologyAnalyzer';
import TypologyAnalyzer from './TypologyAnalyzer';

function mapStateToProps(state) {
  const typologyAnalyzer = state.typologyAnalyzer;
  return {
    isLoading: typologyAnalyzer.get('isLoading'),
    error: typologyAnalyzer.get('error'),
    typologies: typologyAnalyzer.get('typologies'),
    riskIndicators: typologyAnalyzer.get('riskIndicators'),
    explanationGraph: typologyAnalyzer.get('explanationGraph'),
    dataModelFields: typologyAnalyzer.get('dataModelFields'),
    typologyFieldMap: typologyAnalyzer.get('typologyFieldMap'),
    indicatorLogics: typologyAnalyzer.get('indicatorLogics'),
    typologyStructure: typologyAnalyzer.get('typologyStructure')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        analyzeTypologies,
        analyzeTypologiesSuccess,
        resetTypologyAnalysis
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TypologyAnalyzer);
